import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

export default class NewListForm extends React.Component {
  static propTypes = {
    createListFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    resetPageFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.createList = this.createList.bind(this);
  }

  createList = evt => {
    const { createListFunction } = this.props;
    createListFunction(evt);
  };

  render() {
    const { handleSubmit, invalid, submitting, resetPageFunction } = this.props;

    return (
      <div className="row">
        <div className="col-xs-12">
          <Form onSubmit={handleSubmit(this.createList)}>
            <div className="form-group row">
              <div className="col-md-6">
                <Field
                  name="listName"
                  component={InputField}
                  type="text"
                  label="List Name"
                  placeholder="Healthcare List"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={checkButtonDisabled(invalid, submitting)}
                >
                  Create List
                </button>&nbsp;
                <button
                  type="button"
                  onClick={() => {
                    resetPageFunction();
                  }}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}
